<template>
  <div class="author-dianjin-bg">
    <div class="adj-container">
      <div class="adj-left">
        <div class="left-container">
          <ContentLeftTab
            v-bind:tabData="leftTabData"
            v-bind:selectedTab="leftTabSelected"
            @TabChange="TabChange"
          ></ContentLeftTab>
        </div>
      </div>
      <div class="adj-right">
        <div class="right-container">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentLeftTab from '@/components/ContentLeftTab'
export default {
  name: 'Index',
  components: { ContentLeftTab },
  data() {
    return {
      sonRefresh: true,
      leftTabSelected: 1,
      leftTabData: [
        {
          id: 1,
          name: '发布点金',
          path: '/excl-author/dianjin'
        },
        {
          id: 2,
          name: '我的点金',
          path: '/excl-author/dianjin/published'
        },
        {
          id: 3,
          name: '付费明细',
          path: '/excl-author/dianjin/payment',
          subpath: [
            '/excl-author/dianjin/payment/apply',
            '/excl-author/dianjin/payment/apply-result'
          ]
        }
      ]
    }
  },
  created() {
    const path = this.$route.path
    var result = this.leftTabData.findIndex(
      item =>
        item.path === path || (item.subpath && item.subpath.includes(path))
    )
    if (result) {
      this.leftTabSelected = this.leftTabData[result].id
    }
  },
  computed: {},
  methods: {
    TabChange(tab) {
      this.$router.push(tab.path)
    }
  },
  watch: {}
}
</script>
<style lang="scss" scoped>
.author-dianjin-bg {
  background-color: #f0f0f0;
  .adj-container {
    width: 100%;
    min-height: 630px;
    border-radius: 5px;
    display: flex;
    .adj-left {
    }
    .adj-right {
      margin-left: 20px;
      width: 865px;
      height: auto;
      min-height: 500px;
      display: flex;
      flex-direction: column;
    }
  }
}
.left-container,
.right-container {
  // background-color: #ffffff;
  border-radius: 5px;
}
</style>
